<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <SharedWindow :class="b()" @close="handleClose">
    <div :class="b('wrapper')">
      <h2 :class="b('title')">
        {{ $t("Изменение статуса") }} <br />
        {{ $t("пользователя") }} {{ displayedEmail }}
      </h2>

      <div :class="b('form')">
        <div :class="b('field')">
          <p :class="b('field-label')">
            {{ $t("Статус") }}
          </p>

          <SharedSelect
            view="light"
            :options="displayedOptions"
            v-model:value="adminUserAppStatus.status"
          />
        </div>

        <div :class="b('field')">
          <p :class="b('field-label')">
            {{ $t("Комментарий для пользователя (на русском)") }}
          </p>

          <UIInput
            placeholder="Добавьте комментарий при необходимости"
            view="light"
            placeholder-view="light"
            v-model="adminUserAppStatus.messageRu"
          />
        </div>

        <div :class="b('field')">
          <p :class="b('field-label')">
            {{ $t("Комментарий для пользователя (на английском)") }}
          </p>

          <UIInput
            placeholder="Добавьте комментарий при необходимости"
            view="light"
            placeholder-view="light"
            v-model="adminUserAppStatus.messageEn"
          />
        </div>
      </div>

      <UIButton
        :class="b('update')"
        :label="displayedUpdateLabel"
        view="main"
        :disabled="isUpdateDisabled"
        @click="handleChangeStatus"
      />
    </div>
  </SharedWindow>
</template>
